<template>
  <div>
    <div>
      <a-upload
        :before-upload="beforeUpload"
        :customRequest="api"
        list-type="picture-card"
        :file-list="fileList"
        class="avatar-uploader"
        :accept="accept"
        :disabled="disabled"
        @preview="handlePreview"
        @change="handleChange"
      >
        <!-- <div
          v-if="imgsrc"
          class="h-32"
          :style="{
            backgroundImage: `url(${$ossUrl}${imgsrc})`,
            backgroundPosition: 'center center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }"
        /> -->
        <!-- <img
          v-if="imgsrc"
          :src="$ossUrl + imgsrc"
          alt="avatar"
          class="h-full"
          style="max-width: 100% !important; height: auto !important"
        /> -->
        <div>
          <a-icon type="loading" v-if="loading" />
          <a-icon type="plus" v-else />
          <div class="ant-upload-text">上传</div>
        </div>
        <div
          v-if="!disabled"
          class="absolute top-0 w-8 px-1 leading-8 text-center text-white bg-blue-700 rounded-r cursor-pointer hover:bg-blue-800"
          style="height: 128px; left: 135px"
          @click.stop="getQrcode"
        >
          扫码上传
        </div>
      </a-upload>
    </div>

    <a-modal
      title="扫码上传"
      :visible="qrcodeFlag"
      :footer="null"
      @cancel="qrcodeFlag = false"
      forceRender
    >
      <div class="m-auto my-4"> 您可通过手机扫描下方二维码快捷上传对应的材料 </div>
      <div class="m-auto">
        <div id="qrcode" ref="qrcode"></div>
      </div>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" :width="1100">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
  import { v4 as uuidv4 } from 'uuid';
  import QRCode from 'qrcodejs2';
  import { resourceByUUID } from '@/api/resource';
  import { computed } from 'vue';

  export default {
    props: {
      accept: {
        default: 'image/*',
        type: String,
      },
      src: String,
      disabled: Boolean,
    },
    data() {
      return {
        imgsrc: '',
        loading: false,
        uuid: '',
        qrcodeUrl: '',
        qrcodeFlag: false,
        qrcode: '',
        timer: null,
        previewVisible: false,
        previewImage: '',
      };
    },
    mounted() {
      this.imgsrc = this.src;
    },
    watch: {
      qrcodeFlag(a) {
        if (a) {
          this.timer = setInterval(async () => {
            if (this.uuid) {
              let data = await resourceByUUID(this.uuid);
              if (data.pathname != '') {
                clearInterval(this.timer);
                this.qrcodeFlag = false;
                this.$emit('upload', data);
              }
            }
          }, 1000);
        } else {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      },
      src(a) {
        this.imgsrc = a;
      },
    },
    methods: {
      beforeUpload(file) {
        const isLt = file.size / 1024 / 1024 < 50;
        if (!isLt) {
          this.$message.error('上传文件需小于50MB!');
          return false;
        }
        return isLt;
      },
      async api(e) {
        let formData = new FormData();
        formData.append('file', e.file);
        formData.append('where', 'license');
        formData.append('style', '1');
        this.loading = true;
        let res = await this.$uploadfile('/api/v1/file_upload', formData);
        this.imgsrc = res.pathname;
        this.$emit('upload', res);
        this.loading = false;
      },
      getQrcode() {
        this.uuid = uuidv4();
        this.qrcodeUrl =
          'https://' + window.location.host + '/api/v1/upload_file_by_qr/' + this.uuid;
        // this.qrcodeUrl = 'http://192.168.28.73:9091' + '/api/v1/upload_file_by_qr/' + this.uuid;
        if (this.qrcode) {
          this.$refs['qrcode'].innerHTML = '';
        }
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          text: this.qrcodeUrl,
          width: 300,
          height: 300,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.qrcodeFlag = true;
      },
      handlePreview() {
        this.previewImage = this.$ossUrl + this.imgsrc;
        this.previewVisible = true;
      },
      handleCancel() {
        this.previewVisible = false;
      },
      handleChange({ fileList }) {
        this.imgsrc = '';
      },
    },
    computed: {
      fileList() {
        if (this.imgsrc) {
          return [{ uid: 1, url: this.$ossUrl + this.imgsrc, name: '123' }];
        } else {
          return [];
        }
      },
    },
  };
</script>
<style lang="less">
  .avatar-uploader {
    .ant-upload {
      width: 128px;
      height: 128px;

      margin-bottom: 0 !important;
      position: relative;
    }
    .ant-upload-list-picture-card .ant-upload-list-item {
      width: 128px !important;
      height: 128px !important;
    }
    .ant-upload-list-picture-card-container {
      width: 128px !important;
      height: 128px !important;
    }
  }
</style>
<style scoped>
  :deep(.ant-upload-btn) {
    padding: 0 !important;
  }
  :deep(.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete) {
    display: none;
  }
</style>
